
import { connect } from 'react-redux';
import ProfileIconComponent from '../components/ProfileIconComponent';
import { setProfileModalState } from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    isLoggedIn: !!state.profile.jwt,
    user: state.profile.user,
    fetchingProfile: state.profile.fetchingProfile,
    isOpen: state.profile.isOpen,
});

const mapDispatchToProps = (dispatch) => ({
    setProfileModalState: (open) => {
        dispatch(setProfileModalState(open));
    },
});

const ProfileIconContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProfileIconComponent);

export default ProfileIconContainer;
